import React from "react";
import { motion } from "framer-motion";

const HomeAbout = ({ about }) => (
  <section className="py-5 bg-light" id="about">
    <div className="container d-flex flex-wrap align-items-center">
      <motion.div
        className="col-md-6"
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
      >
        <h2 style={{ color:"#0071BD", fontWeight: "700" }}>{about.title}</h2>
        <h5 className="text-muted mb-3">{about.subtitle}</h5>
        <p className="text-secondary lh-lg">{about.description}</p>
      </motion.div>

      <motion.div
        className="col-md-6 text-center"
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
      >
        <img
          src={about.image}
          alt="About Via App"
          className="img-fluid rounded-4 shadow-sm"
        />
      </motion.div>
    </div>
  </section>
);

export default HomeAbout;
